<template>
  <v-card width="100%" max-width="700px" elevation="2" class="pa-0">
    <v-card-title>
      <div class="vc-flex-center">
        <div class="icon-box vc-flex-center pa-1">
          <v-icon size="30px" color="primary">mdi-ballot</v-icon>
        </div>
        <div class="vc-text-primary vc-text-bold vc-font-18 ml-2">
          Agendamento
        </div>
      </div>
    </v-card-title>

    <div class="pl-2 pr-2">
      <div class="vc-divider-grey"></div>
    </div>

    <v-card-title class="pt-0 pb-0 mt-3">
      <div class="vc-flex-center">
        <div class="icon-box vc-flex-center pa-1">
          <v-icon>mdi-briefcase-account</v-icon>
        </div>
        <div class="vc-font-16 ml-2">
          <strong>Profissional da saúde:</strong>
          {{ currentDoctor.name_doctor }}
        </div>
      </div>
    </v-card-title>

    <v-card-title class="pt-0 pb-0 mt-3">
      <div class="vc-flex-center">
        <div class="icon-box vc-flex-center pa-1">
          <v-icon>mdi-account-hard-hat</v-icon>
        </div>
        <div class="vc-font-16 ml-2">
          <strong>Especialidade:</strong> {{ currentSpecialty.name }}
        </div>
      </div>
    </v-card-title>

    <v-card-title class="pt-0 pb-0 mt-3">
      <div class="vc-flex-center">
        <div class="icon-box vc-flex-center pa-1">
          <v-icon>mdi-card-account-details-star</v-icon>
        </div>
        <div class="vc-font-16 ml-2">
          <strong>Plano de Saúde:</strong> {{ currentConvenant.name }}
        </div>
      </div>
    </v-card-title>
    <v-card-title class="pt-0 pb-0 mt-3 mb-3">
      <div class="vc-flex-center">
        <div class="icon-box vc-flex-center pa-1">
          <v-icon>mdi-calendar-month</v-icon>
        </div>
        <div class="vc-font-16 ml-2">
          <strong>Data e hora:</strong> {{ currentSchedule.scheduling }}
        </div>
      </div>
    </v-card-title>
    <v-card-title v-if="procedure" class="pt-0 pb-0 mt-3 mb-3">
      <div class="vc-flex-center">
        <div class="icon-box vc-flex-center pa-1">
          <v-icon>mdi-doctor</v-icon>
        </div>
        <div class="vc-font-16 ml-2">
          <strong>Exame selecionado:</strong> {{ procedure.name }}
        </div>
      </div>
    </v-card-title>
    <!-- <v-card-title class="pt-0 pb-0 mt-3 mb-3">
      <div class="vc-flex-center">
        <div class="icon-box vc-flex-center pa-1">
          <v-icon>mdi-account</v-icon>
        </div>
        <div class="vc-font-16 ml-2">
          <strong>Paciente:</strong>
          
          {{
            currentPatient.username
              ? currentPatient.username
              : currentPatient.name
          }}
        </div>
      </div>
    </v-card-title> -->

    <div class="pl-2 pr-2">
      <div class="vc-divider-grey"></div>
    </div>

    <v-card-actions>
      <v-col cols="12" class="pa-2 text-center">
        <v-btn @click="savePatientSchedule(false)" text color="primary">
          <div class="vc-text-bold">confirmar</div>
        </v-btn>
      </v-col>
    </v-card-actions>
    <v-dialog
      class="auth-dialog-index"
      v-model="showConfirmModal"
      persistent
      max-width="450px"
    >
      <v-card class="vcLightGrey pt-4 pl-4 pb-4 pr-4">
        <v-row class="vc-w-100 ma-0">
          <div @click="closeDialog" class="vc-auth-dialog-close">
            <v-icon color="vcDarkGrey"> mdi-close </v-icon>
          </div>
        </v-row>
        <v-row class="vc-w-100 ma-0 mt-5">
          <div class="vc-font-16 ml-2 text-justify">
            Você já possui agendamentos recorrentes para esse horário. Deseja
            <strong>cancelar todos os agendamentos existentes</strong> e
            <strong>criar novos agendamentos</strong>?
          </div>
          <v-col
            cols="12"
            class="vc-cadaster-form-footer pa-0 text-center mt-4"
          >
            <v-btn @click="savePatientSchedule(true)" depressed color="primary">
              <div class="vc-text-bold">Confirmar</div>
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import ls from 'local-storage';
import axios from 'axios';
export default {
  name: 'card-confirmation',
  data: () => ({
    loading: false,
    feedbackDialog: false,
    showConfirmModal: false,
    modelScheduling: {
      patient_id: '',
      schedule_id: '',
      time: '',
      observation: '',
      return_id: '',
      status: '',
      health_insurance_id: '',
      health_insurance_plans_id: '',
      company_id: '',
      procedure_id: null,
    },
    procedure: null,
  }),
  computed: {
    currentScheduleCompany() {
      return this.$store.getters.currentScheduleCompany;
    },
    currentSchedule() {
      return this.$store.getters.currentSchedule;
    },
    currentConvenant() {
      return this.$store.getters.currentConvenant;
    },
    currentSpecialty() {
      return this.$store.getters.currentSpecialty;
    },
    currentDoctor() {
      return this.$store.getters.currentDoctor;
    },
    currentPatient() {
      return this.$store.getters.currentPatient;
    },
    currentCompany() {
      return this.$store.getters.currentCompany;
    },
  },
  created() {
    this.procedure = ls.get('currentSelectedProcedure');
    if (this.procedure) {
      this.modelScheduling.procedure_id = this.procedure.id;
    }
  },
  methods: {
    closeDialog() {
      this.showConfirmModal = false;
    },

    async sendMessegeWhatsApp(data) {
      this.loading = true;

      const variables = {
        body: {
          0: {
            value: this.currentPatient.people?.name,
            buttonIndex: 0,
          },
          1: {
            value: this.currentDoctor.name_doctor,
            buttonIndex: 0,
          },
          2: {
            value: this.currentSpecialty.name,
            buttonIndex: 0,
          },
          3: {
            value: this.currentConvenant.name,
            buttonIndex: 0,
          },
          4: {
            value: this.currentSchedule.scheduling,
            buttonIndex: 0,
          },
          5: {
            value: this.procedure ? this.procedure.name : 'Não informado',
            buttonIndex: 0,
          },
        },
      };

      const bodyMessage = `
      📅 *Agendamento confirmado!*

      Olá ${
        this.currentPatient.people?.name || ''
      }! Seu agendamento foi realizado com sucesso. Confira os detalhes:

      👨‍⚕️ *Profissional da saúde:* ${this.currentDoctor.name_doctor}
      🩺 *Especialidade:* ${this.currentSpecialty.name}
      🏥 *Plano de Saúde:* ${this.currentConvenant.name}
      🗓️ *Data e hora:* ${this.currentSchedule.scheduling}
      🧾 *Procedimento:* ${
        this.procedure ? this.procedure.name : 'Não informado'
      }

      Em caso de dúvidas ou necessidade de alteração, estamos à disposição 😊
      `.trim();

      let body = {
        company_id: this.currentCompany.id,
        schedule_id: data.schedule_id,
        event_id: data.id,
        body_message: bodyMessage,
        template_id: this.currentCompany.template_id_confirm_consult,
        token: this.currentCompany.new_vchatt_link,
        vchatt_v2_company_id: this.currentCompany.vchatt_company_id,
        quoted_msg: null,
        variables,
      };
      this.$store
        .dispatch('sendMessegeWhatsApp', body)
        .then(() => {
          this.openMoedalMessegeWhatsApp = false;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error, 'error');
          this.loading = false;
        });
    },
    async sendWhatsApp() {
      const url = process.env.VUE_APP_NEW_VCHATT_ENDPOINT;

      if (!url) {
        console.error('Endpoint do WhatsApp não definido');
        return;
      }

      const bodyMessage = `
      📅 *Agendamento confirmado!*

      Olá ${
        this.currentPatient.people?.name || ''
      }! Seu agendamento foi realizado com sucesso. Confira os detalhes:

      👨‍⚕️ *Profissional da saúde:* ${this.currentDoctor.name_doctor}
      🩺 *Especialidade:* ${this.currentSpecialty.name}
      🏥 *Plano de Saúde:* ${this.currentConvenant.name}
      🗓️ *Data e hora:* ${this.currentSchedule.scheduling}
      🧾 *Exame:* ${this.procedure ? this.procedure.name : 'Não informado'}

      Em caso de dúvidas ou necessidade de alteração, estamos à disposição 😊
      `.trim();

      const payload = {
        number: this.normalizeBRWhatsApp(this.currentPatient.people?.phone1),
        body: bodyMessage,
        userId: '',
        queueId: '',
      };

      await axios.post(url, payload, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${this.currentCompany.new_vchatt_link}`,
        },
      });

      this.send_to_whatsapp = false;
    },
    normalizeBRWhatsApp(phone) {
      if (!phone) return '';
      // só números
      let n = phone.replace(/\D/g, '');
      // remove 55 se já vier com DDI
      if (n.startsWith('55')) {
        n = n.slice(2);
      }
      // se tiver 11 dígitos (DDD + 9 + número) → remove o 9
      if (n.length === 11 && n[2] === '9') {
        n = n.slice(0, 2) + n.slice(3);
      }
      return '55' + n;
    },
    savePatientSchedule(val) {
      if (this.currentPatient.username && ls.get('patientId')) {
        this.modelScheduling.patient_id = ls.get('patientId');
      } else {
        this.modelScheduling.patient_id = this.currentPatient.id;
      }
      this.modelScheduling.schedule_id =
        this.currentSchedule.schedule.schedule_id;
      this.modelScheduling.time = this.currentSchedule.schedule.time;
      this.modelScheduling.status =
        this.currentCompany && this.currentCompany.confirmation_event
          ? 'CONFIRMED'
          : 'SCHEDULED';
      this.modelScheduling.health_insurance_id =
        this.currentConvenant.health_insurance_id;
      this.modelScheduling.health_insurance_plans_id = this.currentConvenant.id;
      this.modelScheduling.company_id = this.currentCompany.id;
      this.modelScheduling.specialit_id = this.currentSpecialty.id;
      this.modelScheduling.doctor_id = this.currentDoctor.doctor_id;
      this.modelScheduling.confirm_exclude = val;

      this.$store
        .dispatch('savePatientSchedule', this.modelScheduling)
        .then((resp) => {
          this.$store.commit('SET_NOTIFICATION', {
            type: 'success',
            message: 'Agendamento realizado com sucesso!',
          });

          if (
            this.currentPatient.people?.phone1 &&
            this.currentCompany.new_vchatt_link &&
            !this.currentCompany.template_id_confirm_consult
          ) {
            this.sendWhatsApp();
          } else if (
            this.currentPatient.people?.phone1 &&
            this.currentCompany.new_vchatt_link &&
            this.currentCompany.template_id_confirm_consult
          ) {
            this.sendMessegeWhatsApp(resp);
          }
          this.$router.push({ name: 'Home' });
        })
        .catch(async (error) => {
          var messageError = '';
          switch (error.response.data.message) {
            case 'Já existe agendamento recorrente para esse horário e dia da semana nos próximos 6 meses.':
              messageError = 'Já existe agendamentos nos próximos 6 meses.';
              this.showConfirmModal = true;
              break;
            case 'patient is already scheduled on this time':
              messageError = 'O Paciente já está agendado para esse horário';
              break;
            case 'return event found on check period':
              await this.$swal.fire({
                title: 'Atenção',
                text: 'Identificamos um agendamento recente em seu nome. Por gentileza, entre em contato com a recepção da clínica para dar continuidade.',
                icon: 'warning',
                showCancelButton: false,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Ok!',
              });
              messageError =
                'Identificamos um agendamento recente em seu nome. Por gentileza, entre em contato com a recepção da clínica para dar continuidade.';
              break;
            default:
              messageError =
                'Não foi possivél realizar agendamento, horário não está mais disponivel!';
          }
          this.$store.commit('SET_NOTIFICATION', {
            type: 'danger',
            message: messageError,
          });
        });
    },
  },
};
</script>
